import { Card, CardContent, CardHeader } from '@/src/shadComponents/ui/card';
import { Button } from '@/src/tailwindui/button';
import { Heading, Subheading } from '@/src/tailwindui/heading';
import { useNavigate } from 'react-router-dom';
import QRCode from 'react-qr-code';

export default function DownloadRomr() {
    const navigate = useNavigate();
    return (
        <div className="flex items-center h-screen justify-center dark:bg-[#262C2C] dark:text-white">
            <Card className="w-[90%] md:min-w-[600px] md:w-[600px] rounded-none shadow-none border-0 mb-[200px] md:mb-0">
                <CardHeader>
                    <Heading className="text-4xl plex-sans-bold mb-2 ">
                        Request beta access.
                    </Heading>
                    <Subheading className="text-lg plex-sans-light">
                        Scan or click the QR code below to request beta access.
                    </Subheading>
                </CardHeader>
                <CardContent>
                    <div
                        className="flex flex-col items-center justify-center my-10 cursor-pointer"
                        onClick={() => {
                            window.open(
                                'https://testflight.apple.com/join/BZBF2mwk',
                            );
                        }}
                    >
                        <QRCode
                            size={256}
                            style={{
                                height: 'auto',
                                maxWidth: '250px',
                                width: '100%',
                            }}
                            value="https://testflight.apple.com/join/BZBF2mwk"
                        />
                    </div>

                    <Button
                        className="mt-4 text-xl black-button w-full  disabled:opacity-50 select-none"
                        onClick={() => navigate('/events')}
                    >
                        Continue
                    </Button>
                    <div className="my-4" />
                    <p
                        className="text-xl cursor-pointer plex-sans-bold text-center w-full hidden"
                        onClick={() =>
                            window.open('https://photoengineers.com/faq')
                        }
                    >
                        I need help
                    </p>
                </CardContent>
            </Card>
        </div>
    );
}
